/* eslint-disable max-len */

export default {
  lang: 'English',
  homeScreen: {
    title: 'Secrets Revealed', // Product specific
    stayConnected: 'Stay Connected',
    comingSoon: 'Coming Soon',
  },
  notification: {
    newAndNow: 'New & Now!',
    alert: 'Alert',
    message: 'Message',
    contest: 'Contest',
    badge: 'New Badge',
    'content-update': 'Content Update',
    events: 'Events',
    other: 'Notification',
  },
  loginScreen: {
    title: 'Travel Professional Training and Sales Enablement Program', // Product specific (TravPRO text or ChannelPRO text)
    welcome: {
      headerTop: 'Welcome to the',
      headerBottom: 'BVI Revealed Specialist Program', // Product specific
    },
    sellingPoints: {
      // All selling points can be product specific
      0: 'Everyday Sales Conversion Resource',
      1: 'High impact Discovery & Presentations',
      2: "Personalize with 'favorites' folder",
      3: 'Online, Offline - Anytime, Anywhere',
      4: 'Share, Connect, Convert',
    },
    emailPrompt: 'Please enter your email address to confirm that you are a travel professional.', // Product specific (TravPRO or ChannelPRO text)
    tAndC: {
      agree: 'By continuing you agree with our ',
      privacyPolicy: 'privacy policy',
      and: ' and ',
      termsConditions: 'terms and conditions',
    },
    fields: {
      what: 'What type of travel do you sell?',
      what1: 'What is the #1 type of travel you sell?',
      what2: 'What is the #2 type of travel you sell?',
      what3: 'What is the #3 type of travel you sell?',
      agency: 'Agency *',
      email: 'Email',
      password: 'Password *',
      passwordConfirm: 'Confirm your password *',
      firstName: 'First name *',
      lastName: 'Last name *',
      agencyName: 'Agency Name *',
      city: 'City *',
      stateProvince: 'State / Province *',
      salutation: 'Salutation *',
      required: 'Required',
      invalidEmail: 'Invalid email address',
      opt: "Stay In Touch! Yes, I'd like to opt in to communications from The British Virgin Islands that will keep me posted on news, events, incentives, FAM’s and more!",
      complete: 'Step 2: Complete your profile',
      tell: 'Tell Us About Yourself',
      title: 'Business Title *',
      host: 'Host Agency Name',
      country: 'Country / Region',
      select: 'Please select an option below',
      header2: 'Which segment(s) do you primarily sell?',
      step2: 'Describe Your Business',
      leisure: 'Leisure',
      corporate: 'Corporate',
      group: 'Group',
      affiliate: 'What is Your Main Affiliation?',
      forgot:
        'Forgot your password? Click the button below and we’ll send you an email to reset your password.',
    },
    noAgent: {
      noAgentButton: "I'm not an advisor",
      title: 'Thank you for your interest in the British Virgin Islands.', // Product specific
      messageWeb:
        'The content on this site is exclusively for travel professionals. \n To learn more about the British Virgins Islands, please visit: ', // Product specific
      messageMobile:
        "Some content on this app is exclusively for travel professionals, but feel free to browse a preview of what this app has to offer by pressing 'Continue'.", // Product specific
      continue: 'Continue',
      visitWebsite: 'Visit website',
    },
    newUser: 'New User',
    register: 'Register',
    registered: 'This email is already registered',
    forgot: 'Reset Password',
    header:
      'Please take a moment to complete all the information below, as this is what will populate your profile and contact information.',
    step1: 'Step 1: Complete your email address',
    version2: {
      homeTitle: "Let's see if we can find an existing profile for you in our system.",
      homeTitleSub: 'Enter the email address you typically use to login to training programs.',
      noAccount:
        'No account found ({email}), please try with another email or create an account now.',
      continueButton: 'Continue',
      success:
        'Successfully updated your account! You will be redirected shortly to the home page.',
      successNewAccount:
        'To complete your registration, you will receive a confirmation email to verify your account.',
      loginButton: 'Login',
      matchFound: 'We have found a match, please fill in your password to continue.',
      magicLink: 'Login via a link in your email:',
      magicLinkButton: 'Request Magic Link',
      magicLinkTitle: 'Get a direct link sent to your email that will sign you in instantly.',
      otherEmailButton: 'Submit',
      title:
        'Please take a moment to complete all the information below as it will populate your personal profile and contact information.',
      titleIndustry:
        'Please take a moment to complete all the information below as it will populate your personal profile and contact information.',
      register: 'Create an account',
      agent: 'Travel Advisor',
      visitor: 'Industry Visitor',
      step1: 'Step 1: Type of User',
      step2: 'Step 2: Create An Account',
      step3: 'Step 3: Create Your Profile',
      marketingOptIn:
        'Are you sure you are not interested in staying connected to this program’s travel trade team?',
      optIn: 'Yes, I’m Interested',
      optOut: 'Not Interested',
      step2Sub1: 'Tell Us About Yourself',
      step2Sub2: 'Tell Us About Your Business',
      privacyHead: 'COMMUNICATIONS PREFERENCES',
      privacySub:
        'Check the boxes below to ensure you receive important communications from the supplier’s travel trade team (product updates and announcements, rewards, incentives, FAMs, etc.) and travel trade networking and sales support initiatives from TravPRO Mobile.',
      privacy: 'We protect your privacy and never sell, misuse or betray your trust.',
      store: 'Easily download this program at your app store:',
      powered: 'POWERED BY',
      toastMessage: {
        forgotSuccess:
          'We have e-mailed your password reset link! You will be redirected to the login page in 10 seconds.',
        emailNotExisting: "The email address you entered doesn't exist.",
        magicLinkMessage: 'Please wait, we are signing you in right now.',
        magicLinkError:
          "We couldn't find your account in our database, please log in manually. You will be redirected in 10 seconds.",
        magicLinkError1:
          "We couldn't find a valid token, please login or request a new magic link. If this problem persists, please contact us at: info@travpromobile.com.",
        magicLinkError2:
          "We couldn't find your account in our database, please log in manually. You will be redirected in 10 seconds.",
        magicLinkSuccess: "Check your email at {email}. It has a magic link that'll sign you in.",
        magicLinkErrorWait: 'Please wait 5 minutes in between magic link requests.',
        emailNotFoundError:
          'The email address you entered can’t be found in our records. Please check for misspellings or create an account.',
      },
      errors: {
        zipCodeNotFound: 'ZipCode not found, try again',
        zipCodeOnlyNumbers: 'ZipCode can only contain numbers',
        password: 'Please enter a password',
        passwordNotMatching: 'The passwords you entered do not match',
        passwordTooShort: 'Password needs to be at least 8 characters',
        emailExists:
          'This email address already exists or is invalid. Please try with another email address or login to your account.',
        fillInAllFields: 'Please fill in all the required fields',
        fillInEmail: 'Please fill in your email.',
        emailNotExisting: "The email address you entered doesn't exist.",
      },
      fields: {
        forgotSubCopy: 'Forgot your password & want to change it? ',
        forgotSubCopy2:
          'Want to bypass password entirely? We will send you an email with a magic link that will automatically log you into the program. ',
        city: 'City',
        companyName: 'Company Name',
        role: 'Your Role',
        description: "Which best describes your company's business?",
        country: 'Country',
        password: 'Password',
        passwordRegister: 'Choose Password (8 character minimum)',
        passwordConfirm: 'Confirm Password',
        firstName: 'First Name (Given)',
        lastName: 'Last Name (Family)',
        agency: 'Your Agency Name',
        title: 'Your Role (Select One)',
        company: 'Company Name',
        select: 'Select an option below',
        state: 'State',
        province: 'Province/Region/State',
        zipCode: 'Zip Code',
        postalCode: 'Postal Code',
        affiliate: 'Which group is your MAIN agency affiliation?',
        hostAgency: 'Your Host Agency?',
        executive: 'Executive',
        management: 'Management',
        marketing: 'Marketing',
        sales: 'Sales',
        coordinator: 'Coordinator',
        opt: "Stay connected to this program's travel trade team and receive updates.",
        optMarketing: 'Stay connected to TravPRO regarding similar programs and events.',
        retail: 'Retail Store Front',
        home: 'Home-Based Agent',
        independent: 'Independent Contractor',
        host: 'Host Agency',
        call: 'Call Center or Web-Based Agency',
        other: 'Other ',
        describes: 'What best describes you and your agency’s business? ',
      },
    },
  },
  welcomeScreen: {
    title: 'Welcome to the\n BVI Revealed Specialist Program', // Product specific
    helloUser: 'Hello {name}',
    hello: 'Hello,',
    fromAgency: 'from {agency}',
    notUser: 'Not {name}?',
    introOnline:
      "Train immediately online or preload the content so it's always available for offline use!",
    introOffline:
      'You already have the latest version preloaded. Start training or selling anytime, anywhere!',
    startTraining: 'Start training',
    continueTraining: 'Continue training',
    graduated: 'Congratulations!',
    downloader: {
      preload: 'Preload',
      stop: 'stop',
      init: 'Initializing...',
      lastUpdate: 'Last update: ',
    },
  },
  trainingScreens: {
    badge: 'View Badge',
    review: 'Review',
    start: 'Start',
    continue: 'Continue',
    restart: 'Restart',
    durationInMinutes: '{number} minutes',
    percentageComplete: '{number}% Complete',
    unlock: 'Unlock this chapter by completing training chapter {number}.',
    unlockSpecialization: 'Unlock this chapter by completing The Foundation',
    unlockSubtitle: 'Unlock more chapters by completing training chapters.',
    allUnlocked: 'You have unlocked all chapters!',
    certificate: 'Certificate',
    courseComplete: 'Course complete!',
    endReached: "You've reached the end",
    retainEnd:
      'Use the top bar to navigate around in this chapter or press the back button to return to the overview.',
    watchListenRead: 'Watch, Listen & Read more',
    trouble: "It looks like you're having trouble, would you like to skip this question?",
    incorrect: "Sorry! That's incorrect.",
    mistake: 'mistake',
    mistakes: 'mistakes',
    tooManyMistakes:
      "You've made 3 mistakes. We recommend you visit the training section for more training.",
    confirm: 'Confirm your answer',
    choose: 'Please choose an answer',
    skip: 'Skip question',
    next: 'Next question',
    retry: 'Try Again',
    fastTrack: 'Would you like to enter the Fast Track course?',
    fastTrackButton: 'Fast Track',
    grading: 'Your final grade is a{n} {grade}',
    fastTrackText: {
      failed: 'We suggest visiting the train section to refresh your memory.',
    },
    foundation: 'The Foundation',
    foundationSub: 'Complete these essential modules to earn your certificate.',
    specialization: 'The Experience',
    specializationSub: 'Up your game and earn a badge for each specialization module below.',
  },
  nav: {
    home: 'Home',
    train: 'Train',
    retain: 'Retain',
    rewards: 'Rewards',
    directory: 'Directory',
    promote: 'Promote',
    sell: 'Sell',
    info: 'Info',
    media: 'Media',
    favorites: 'Favorites',
    contact: 'Contact',
    reportCard: 'View Diploma >',
    accountSettings: 'Account Settings',
    messages: 'Messages',
    search: 'Search',
  },
  contentHeaders: {
    train: 'Training Library',
    retain: 'Retain',
    subapps: 'Partner Specialist Programs',
  },
  sharing: {
    copyURL: 'Copy link',
    copied: 'Copied!',
  },
  pageDescriptions: {
    train: 'Educate, engage and become the expert.',
    retain:
      'Your go-to resource for retaining your expert knowledge and enabling your sales efforts. Use this area to expertly answer a product question or even as an impromptu sales presentation — anytime, anywhere and from any device',
    promote:
      'Share these items to ignite interest and start a conversation with clients and prospects.',
    sell: 'Answer client questions and close the sale like a pro with deep resources and targeted sales support.',
    favorites: 'Check out your personally favorited content',
    search: 'Look through all content',
    subapps: 'Be the expert on our preferred BVI partner(s).',
  },
  general: {
    next: 'Next',
    previous: 'Previous',
    submit: 'Submit',
    back: 'Back',
    close: 'Close',
    yes: 'Yes',
    no: 'No',
    page: 'Page',
    search: 'Search',
    logIn: 'Log in',
    logOut: 'Log Out',
    viewItem: 'View {type}',
    imageNotFound: 'Image not found',
    noResultsFor: 'No results have been found for: {{query}}',
    noFavorites: "You don't have any favorites yet.",
    noMessages: "You haven't received any messages yet!",
    resultsFor: 'Results for: {query}',
    showAll: 'Show all',
    connectionError: 'Connection error',
    alreadyExists: 'Already exists',
    pageNotFound: '404 Page Not Found!',
    oops: 'Uh oh...',
    overview: 'Return to overview',
    courseComplete: 'Course Complete!',
    chapterComplete: 'Chapter Complete!',
    message: '{count} Message',
    messagePlural: '{count} Messages',
    rewards: 'View Video >',
    from: 'From',
    to: 'To',
  },
  messageCenter: {
    dayAgo: '1 day ago',
    monthAgo: '1 month ago',
    yearAgo: '1 year ago',
  },
  itemTypes: {
    image: 'Image',
    brochure: 'Collection',
    layout: 'Layout',
    web: 'Website',
    pdf: 'PDF',
    carousel: 'Collection',
  },
  collectionView: {
    main: 'Home',
    sell: 'Sell',
    promote: 'Promote',
  },
  questions: {
    dials: 'Rotate the dials to match the answer',
    fitb: 'Fill in the blank(s)',
    flip: 'Change the number to match the answer',
    multipleChoice: 'Pick the right answer(s)',
    slider: 'Pick the right answer using the slider',
    map: 'Answer the question by tapping the right location on the map',
    dropdown: 'Choose...',
    true: 'True',
    false: 'False',
  },
  reportCard: {
    download: 'Download',
    email: 'Email',
    print: 'Print',
    confirm: 'Close',
  },
  cookies: {
    consent: 'AGREE',
    optout: 'Opt-out',
    settings: 'Privacy Settings',
    message:
      "You haven't told us anything about your data privacy preferences! That's ok, but we'd like to offer you the best experience using the Sales Companion.",
    disabled: 'It looks like you have disabled the use of cookies.',
    use: 'The {{appName}} requires the use of cookies to deliver you the best experience.',
    details: 'What are the cookies used for?',
    enable: 'See how to enable your cookies {{here}}.',
    here: 'here',
  },
  notLoggedIn: {
    super: "You're not logged in",
    title: 'You need to be logged in to view this content',
    guest: 'Guest',
  },
  demo: {
    message:
      'This website is a demo of the final product. It is currently in-development and not a complete product.',
    consent: 'Understood!',
  },
  share: {
    header: 'Share this resource:',
    download: 'download',
  },
  errors: {
    comingSoon: 'Coming soon...',
    missingContent: 'The requested content is still in production.',
  },
  breadCrumbs: {
    page: 'Page',
  },
  onMobile: {
    header: "It looks like you're trying to access the {appName} app from a mobile device",
    body: 'To download this program simply visit your app store and search for {appName} or click one of the buttons below',
    benefits: {
      header: 'This will provide you with:',
      1: 'Portability',
      2: 'No need for WiFi, train when and where convenient',
      3: 'Sales tools & resources at your fingertips',
    },
    continue: 'Continue anyway',
  },
  points: {
    pointsToLevel: '{pointsToLevel} {points} until you have reached the {rank} ranking!',
    outOf: '{points} XP out of',
    pointsToRank: '{pointsToLevel}XP needed to rank:  ({rank})',
  },
  rewards: {
    rewards: 'Rewards',
    title: 'Welcome to the Rewards Center',
    subheader: 'Track and Share Booking Submissions and Rewards',
    subTitle:
      'We’re giving you a chance to win rewards for becoming a specialist with our program, and booking travel to Puerto Rico!',
    body: 'Book travel to Puerto Rico for your chance to win! Enter your bookings for eligibility to earn an Introductory Incentive Reward of $5 US/CAN E-gift Card.',
    item1:
      'After your first confirmed booking of 4-nights or more, (for an individual reservation), for a minimum of two (2) passengers, at a qualifying hotel/resort. (Cruises do not qualify.)',
    item2:
      'Offer valid after Essential Modules of the Puerto Rico Travel Specialist Program are completed.',
    link1: 'Have you booked Puerto Rico? ',
    link2: 'If so, submit your booking here.',
    button: 'Submit your booking',
    products: 'Marketplace',
    viewAllBookings: 'Bookings',
    viewLeaderboard: 'Leaderboard',
    viewDashboard: 'Points Dashboard',
    viewRewards: 'Overview',
    overview: {
      title:
        'Earn Points & Cash rewards for your Discover Puerto Rico training, sharing and bookings.*',
      grand: 'Cash Rewards for Every Booking More Than 3 Nights',
      grandPrize: 'USD $50 per every 3-5 nights stay',
      grandPrizeSecond: 'USD $100 per every 6+ Nights stay',
      first: 'Monthly Prizes',
      firstPrize:
        'Chances to win part of $500 for the travel advisors booking the highest number of guests to any Discover Puerto Rico property.',
      second: 'Grand Prizes',
      secondPrize:
        'Rooms, Upgrades, Site inspection FAMs., Swag, and more to surprise and delight our valued advisors.',
      choosen: 'Point Based Redemption Marketplace',
      choosenPrize:
        'Use point that you earn along the way for ALL activities including booking submissions, training, and sharing ccollateral with your clients.',
      valid: "*Bookings entered are valid only after client's travel is completed.",
    },
    home: {
      entries: 'Current Entries',
      trainingAchievements: 'TRAINING ACHIEVEMENTS',
      trainingAchievementsText:
        'Track your training progress, certifications, and metallic rewards status on this page. You’ll also be able to download and share your Discover Puerto Rico Travel Specialist diploma, as well as any badges you’ve earned in Experiences and Partner Specializations.',
      bookingContests: 'BOOKINGS DASHBOARD',
      bookingContestsText:
        'Easily track and manage current booking submissions on the Bookings Dashboard. ',
      submitBooking: 'SUBMIT BOOKINGS',
      submitBookingText: 'This is where you’ll submit bookings for inclusion in booking contests.',
      currentContest: 'CURRENT CONTEST',
      currentContests: 'CURRENT CONTESTS',
      contestTerms: 'Terms & Conditions',
      noContest: 'Contest is currently not available.',
    },
    bookingRewardsView: {
      title: 'Marketplace',
    },
    bookingsView: {
      title: 'Bookings',
    },
    leaderboardScreen: {
      title: 'POINTS \n Leaderboard',
      earnedpts: 'MY POINTS EARNED​:',
      pointsWall: 'POINTS TOP 5 TRACKER​:',
      startEarning: "Start now earning XP's and join the leaderboard!",
      prizes: 'Prizes',
      tAndC: 'Terms and Conditions apply*',
      pointsOverview: {
        title: 'How to earn points',
        booths: 'Visit Exhibitor Showcases',
        breakoutSessions: 'Attend Breakout Sessions & Destination Spotlights',
        trainingSessions: 'Complete a Training Chapter',
        adventureSpotlights: 'Family Travel Tips',
        share: 'Sharing Content',
        shareMax: '(up to {maxSharePoints} points)',
        shareInfo:
          'Sharing is counted by sharing booth content to Twitter and Facebook or sharing the entire booth with colleagues or clients.',
        viewVideo: 'View Video',
      },
    },
    dashboardView: {
      title: 'Bookings Dashboard',
      subtitle: 'Track and Manage Your Booking Entries Here.',
      badge: 'Badges',
      activity: 'Bookings Dashboard',
      manage: 'Manage Bookings',
      manageSub:
        'Sort using buttons above and click any record to manage submission details. All pending entries will be verified within 72 hours. ',
      noBookings: 'There are no records to display.',
      state: {
        approvedEntries: 'Approved Entries',
        pendingEntries: 'Pending Entries',
        declinedEntries: 'Declined Entries',
        viewAll: 'View All',
      },
    },
    bookingForm: {
      title: 'Booking Submission Form',
      subTitle: 'Enter your booking:',
      required: '* Indicates a required field',
      email: 'Agent Email',
      agentFirstName: 'Agent First Name',
      agentLastName: 'Agent Last Name',
      company: 'Company name',
      iata: 'IATA/CLIA #',
      stateProvince: 'State/ Province',
      postalCode: 'Zip Code *',
      country: 'Country',
      bookingNumber: 'Booking Confirm Number',
      numberOfGuests: 'Number of Adult Guests',
      bookingDate: 'Booking Date',
      tourOperator: 'Tour Operator / Booking Method',
      firstName: 'First Name',
      lastName: 'Guest Last Name',
      accommodation: 'Hotel, Villa, Charter Company',
      select: 'Select an option',
      wholesaler: 'Wholesaler Name (if applicable): if this is a direct booking, enter NONE',
      arrivalDate: 'Check-In Date',
      departureDate: 'Check-Out Date',
      lengthOfStay: 'Length of Stay (in Nights)',
      reservationNumber: 'Reservation Number',
      rooms: 'Number of Rooms',
      stay: 'Length of Stay (in Nights)',
      airline: 'Airline / Carrier (2-digit code)',
      originAirport: 'Origin Gateway (3-letter airport code)',
      destination: 'Destination / Island (3-letter airport code)',
      cost: 'Total Cost of Booking (only use decimals)',
      file: 'RezSnap™ Proof Upload',
      disclaimer: '* Required fields',
      button: 'Submit your booking',
      sub: 'Your information',
      sub2: 'Booking information',
      guests: 'Number of Passengers',
      propertyCharterCompany: 'Property / Charter Company',
    },
    TermsAndConditions: {
      title: 'Terms and Conditions',
      subTitle: 'Bahamas Specialist Quarterly Rewards',
      body1:
        'All posting must be accompanied by a zero-balance proof of sale document that corresponds with each individual booking that you have posted. Postings must follow all BVI Specialist Rewards rules for eligibility. Awards are not transferable and must be redeemed within in 12 months of award notification.',
      body2:
        'Tour Operator employees are eligible for the monthly drawing but will NOT be considered for additional prizes. To be eligible you must reside in the US or Canada. Individuals can only win the monthly prize once during any 6-month period.',
      body3:
        'Travel Reward issuance may require proof of accreditation as a retail/home-based travel counselor. Travel Reward redemptions will be issued as certificates for two travelers. Available rewards are subject to change during the course of the program. Travel Awards may have certain other restrictions including holiday and peak season black-outs. Actual Travel Award reservations are the responsibility of the winning agent and the ground package provider. Participants may not transfer or sell the certificates.',
      body4: 'Privacy and Use of Personal Information',
      body5:
        'Participating agents (i) grants to the Rewarder the right to use his/her name, city, state, province, postal code, age of majority confirmation, telephone number and e-mail address for including but not limited to contacting and announcing the Awardees and provision of awards; (ii) grants to the Awardee the right to use his/her personal information for publicity and promotional purposes relating to the awards, in any and all media now known or hereafter devised, without further compensation unless prohibited by law; and (iii) acknowledges that the Awardees may disclose his/her personal information to third-party agents and service providers in connection with any of the activities listed in (i) and (ii) above.',
      button: 'Return to Rewards',
    },
    thankYouPage: {
      thanks: 'Thank you',
      congrats: 'Congratulations, ',
      body: 'your booking has been received and sent to the campaign supervisor for verification.',
      link: 'Please note to be a winner, you must have completed the Essential Modules of the Bahamas Specialist Program',
    },
    menu: {
      home: 'Rewards\nContest',
      achievements: 'Training\nAchievements',
      bookings: 'Bookings\nDashboard',
      form: 'Submit\nBookings',
    },
  },
  search: {
    pages: 'Pages',
    resources: 'Resources',
  },
};
